module.exports = __webpack_public_path__ + "img/clouds.d474ed65.png";